import type {
  ChannelCatalogItem,
  ChannelCatalogResponse,
  ChannelCatalogSection,
} from "../api/connectionHub.types";

const compareChannels = (
  left: ChannelCatalogItem,
  right: ChannelCatalogItem
): number => {
  if (left.isSuggested !== right.isSuggested) return left.isSuggested ? -1 : 1;
  const fillOrder = left.capability.fillOrder - right.capability.fillOrder;
  if (fillOrder !== 0) return fillOrder;
  return left.ipName.localeCompare(right.ipName, undefined, { sensitivity: "base" });
};

export const orderChannels = (
  channels: ChannelCatalogItem[]
): ChannelCatalogItem[] => [...channels].sort(compareChannels);

export const orderCatalogSections = (
  catalog: ChannelCatalogResponse | null
): ChannelCatalogSection[] =>
  catalog?.sections.map((section) => ({
    ...section,
    channels: orderChannels(section.channels),
  })) ?? [];
